import React from 'react';

export const BottomPlaceholderDataHook = 'bottom-placeholder';

export class BottomPlaceholder extends React.Component {
  public render(): JSX.Element {
    return <div data-hook={BottomPlaceholderDataHook} />;
  }
}
